/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {toCardinal} from '@ion/dls/src/maps/helpers/MapViewUtils';
import {dlsColor, dlsLayout} from '@ion/dls/src/theme/theme';

export interface SpeedCellType {
  heading: number,
  value: number,
}

const useStyles = makeStyles(theme => ({
  speedValueCell : {
    display        : 'flex',
    justifyContent : 'flex-start',
    alignItems     : 'center',
    height         : '100%'
  },
  cardinal : {
    color       : dlsColor('caBlue'),
    marginRight : dlsLayout('spacing') / 2
  }
}));

/**
 * @SpeedCell
 *
 * Grid renderer component to Display asset Speed with cardinal
 *
 */
export const SpeedCell = ({value, heading}: SpeedCellType) => {
  const classes = useStyles();
  return (
    value ? (
      <div className={classes.speedValueCell}>
        <span className={classes.cardinal}>{toCardinal(heading)}</span>
        <span>{value}</span>
      </div>
    ) : null
  );
};

export default SpeedCell;
